<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import prototype from '@assets/js/prototype'
export default {
  name: 'App'
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue